export var CalculatorConfig = {
    MIN_SUM_DEFAULT: 1000,
    MIN_SUM_DEFAULT_TEXT: '1000 руб.',
    MAX_SUM_DEFAULT: 100000,
    MAX_SUM_DEFAULT_TEXT: '100 тыс. руб.',
    MIN_SUM_AUTOLOAN: 50000,
    MIN_SUM_AUTOLOAN_TEXT: '50 тыс. руб.',
    MAX_SUM_AUTOLOAN: 1000000,
    MAX_SUM_AUTOLOAN_TEXT: '1 млн. руб.',
    DEFAULT_SUM: 50000,
    DEFAULT_SUM_TEXT: '50 тыс. руб.',
    DEFAULT_PERIOD: { value: 364, vr: 1 },
    DEFAULT_PERIOD_TEXT: '364 дня',
};
export var PaymentVariants = {
    MAIN_DEBT_AT_END: 'Основной долг в конце срока',
    EQUAL_PAYMENTS: 'Равные платежи',
};
export var JustZeroConfig = {
    MAX_SUM: 15000,
    MAX_SUM_TEXT: '15 тыс. руб.',
    PERIOD: 7,
    PERIOD_OBJECT: { value: 7, vr: 0, }
};
export var declinationTermDays = ['день', 'дня', 'дней'];
export var declinationTermMonths = ['месяц', 'месяца', 'месяцев'];
export var declinationPayments = ['платёж', 'платежа', 'платежей'];
export var initialTerm = { value: 0, vr: 0 };
